export default __webpack_public_path__ + "05c8bd2.png";